(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["created-artisan-gift-set"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ca-gift-set]').forEach((builder) => {
    if (builder.dataset.initialized === 'true') return;
    builder.dataset.initialized = 'true';
    const form = builder.querySelector('[data-ca-gift-set-form]');
    if (!form) return;
    const selects = [...form.querySelectorAll('select[data-role]')];
    const submit = form.querySelector('[data-ca-gift-set-submit]');
    const status = form.querySelector('[data-ca-gift-set-status]');
    globalThis.caGiftSetCollections ||= new Map();
    const loadCollection = async (handle) => {
      if (!handle) return [];
      if (!globalThis.caGiftSetCollections.has(handle)) {
        const root = globalThis.Shopify?.routes?.root || '/';
        const url = `${root}collections/${handle}/products.json?limit=250`;
        globalThis.caGiftSetCollections.set(
          handle,
          fetch(url, {headers: {Accept: 'application/json'}})
            .then((response) => {
              if (!response.ok) throw new Error('collection-load-failed');
              return response.json();
            })
            .then((payload) => payload.products || [])
        );
      }
      return globalThis.caGiftSetCollections.get(handle);
    };
    const populateSelect = async (select) => {
      const products = await loadCollection(select.dataset.collectionHandle);
      if (!products.length) return;
      select.caProducts = products;
      const placeholder = select.options[0];
      select.replaceChildren(placeholder);
      products.forEach((product) => {
        const variant = product.variants.find((item) => item.available) || product.variants[0];
        if (!variant) return;
        const option = new Option(product.title, String(variant.id));
        option.disabled = !variant.available;
        if (!variant.available) option.textContent += ` — ${select.dataset.soldOutText}`;
        select.append(option);
      });
    };
    const dialog = document.createElement('dialog');
    dialog.className = 'ca-gift-set__picker-dialog';
    dialog.innerHTML = `
      <div class="ca-gift-set__picker-header">
        <h3 class="ca-gift-set__picker-title"></h3>
        <button class="ca-gift-set__picker-close" type="button" aria-label="${builder.dataset.pickerClose}">×</button>
        <input class="ca-gift-set__picker-search" type="search" placeholder="${builder.dataset.pickerSearch}">
      </div>
      <div class="ca-gift-set__picker-grid"></div>
      <p class="ca-gift-set__picker-no-results" hidden>${builder.dataset.pickerNoResults}</p>
    `;
    form.append(dialog);
    const pickerTitle = dialog.querySelector('.ca-gift-set__picker-title');
    const pickerSearch = dialog.querySelector('.ca-gift-set__picker-search');
    const pickerGrid = dialog.querySelector('.ca-gift-set__picker-grid');
    const noResults = dialog.querySelector('.ca-gift-set__picker-no-results');
    dialog.querySelector('.ca-gift-set__picker-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    let activeSelect;
    const imageSource = (product) => {
      const image = product.images?.[0] || product.image || product.featured_image;
      return typeof image === 'string' ? image : image?.src;
    };
    const updateTrigger = (select) => {
      const trigger = select.caTrigger;
      if (!trigger) return;
      const option = select.selectedOptions[0];
      const product = select.caProducts?.find((item) => item.variants.some((variant) => String(variant.id) === select.value));
      const image = trigger.querySelector('img');
      const title = trigger.querySelector('[data-picker-selected]');
      title.textContent = option?.textContent || select.options[0].textContent;
      const src = product && imageSource(product);
      image.hidden = !src;
      if (src) image.src = src;
    };
    const renderPicker = (select, query = '') => {
      const normalized = query.trim().toLocaleLowerCase();
      const products = (select.caProducts || []).filter((product) => product.title.toLocaleLowerCase().includes(normalized));
      pickerGrid.replaceChildren();
      products.forEach((product) => {
        const variant = product.variants.find((item) => item.available) || product.variants[0];
        if (!variant) return;
        const card = document.createElement('button');
        card.type = 'button';
        card.className = 'ca-gift-set__picker-card';
        card.disabled = !variant.available;
        card.setAttribute('aria-pressed', String(select.value === String(variant.id)));
        const src = imageSource(product);
        if (src) {
          const image = document.createElement('img');
          image.src = src;
          image.alt = '';
          image.loading = 'lazy';
          card.append(image);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'ca-gift-set__picker-placeholder';
          placeholder.textContent = '🎁';
          card.append(placeholder);
        }
        const title = document.createElement('span');
        title.textContent = variant.available ? product.title : `${product.title} — ${select.dataset.soldOutText}`;
        card.append(title);
        card.addEventListener('click', () => {
          select.value = String(variant.id);
          select.dispatchEvent(new Event('change', {bubbles: true}));
          updateTrigger(select);
          dialog.close();
        });
        pickerGrid.append(card);
      });
      noResults.hidden = pickerGrid.childElementCount > 0;
    };
    const enhanceSelect = (select) => {
      if (!select.caProducts?.length) return;
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'ca-gift-set__picker-trigger';
      trigger.innerHTML = '<img alt="" hidden><span data-picker-selected></span><span aria-hidden="true">›</span>';
      const label = select.labels?.[0]?.textContent || select.closest('fieldset')?.querySelector('legend')?.textContent || '';
      trigger.setAttribute('aria-label', `${builder.dataset.pickerChange}: ${label}`);
      select.caTrigger = trigger;
      select.hidden = true;
      select.insertAdjacentElement('afterend', trigger);
      updateTrigger(select);
      trigger.addEventListener('click', () => {
        activeSelect = select;
        pickerTitle.textContent = label;
        pickerSearch.value = '';
        renderPicker(activeSelect);
        dialog.showModal();
        pickerSearch.focus();
      });
    };
    pickerSearch.addEventListener('input', () => {
      if (activeSelect) renderPicker(activeSelect, pickerSearch.value);
    });
    const refresh = () => {
      submit.disabled = !selects.every((select) => select.value);
    };
    selects.forEach((select) => select.addEventListener('change', refresh));
    refresh();
    Promise.all(selects.map(populateSelect))
      .then(() => {
        selects.forEach(enhanceSelect);
        refresh();
      })
      .catch(() => refresh());
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      submit.disabled = true;
      status.dataset.error = 'false';
      status.textContent = submit.dataset.loadingText;
      const group = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      const items = selects.map((select) => ({
        id: Number(select.value),
        quantity: 1,
        properties: {
          _ca_gift_set: builder.dataset.giftSetHandle,
          _ca_gift_set_group: group,
          _ca_gift_set_role: select.dataset.role,
        },
      }));
      try {
        const response = await fetch(builder.dataset.addUrl, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items}),
        });
        if (!response.ok) throw new Error('cart-add-failed');
        globalThis.location.assign(builder.dataset.cartUrl);
      } catch (error) {
        status.dataset.error = 'true';
        status.textContent = submit.dataset.errorText;
        refresh();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mix-match-offer"] && !Shopify.designMode) return;
  try {
    
  const mixMatchFamilies = {
    earrings: ['Boucles d’oreilles', 'Earrings', 'Oorbellen', 'Ohrringe'], raclette_scrapers: ['Racloir à raclette'], bottle_openers: ['Décapsuleur'], wooden_pens: ['Stylo en bois'], wooden_stylus_pens: ['Stylet tactile en bois'], cork_trivets: ['Sous-plat'], slate_coasters: ['Sous-verre en ardoise'], smartphone_stands: ['Support smartphone'], hair_brushes: ['Brosse à cheveux']
  };
  const updateMixMatch = async (root) => {
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    if (!response.ok) return;
    const cart = await response.json();
    const productTypes = mixMatchFamilies[root.dataset.family] || [];
    const quantity = cart.items.filter((item) => productTypes.includes(item.product_type)).reduce((total, item) => total + item.quantity, 0);
    const tiers = root.dataset.tiers.split(',').map((tier) => Number(tier.split(':')[0]));
    const reached = [...tiers].reverse().find((tier) => quantity >= tier) || tiers[0];
    const next = tiers.find((tier) => tier > quantity);
    root.querySelectorAll('[data-tier]').forEach((tier) => tier.classList.toggle('is-current', Number(tier.dataset.tier) === reached));
    const progress = root.querySelector('[data-mix-match-progress]');
    if (!progress) return;
    progress.textContent = next ? root.dataset.progress.replace('[count]', String(next - quantity)).replace('[tier]', String(next)) : root.dataset.complete;
  };
  const initializeMixMatch = () => document.querySelectorAll('[data-mix-match]').forEach((root) => updateMixMatch(root).catch(() => {}));
  document.addEventListener('DOMContentLoaded', initializeMixMatch);
  document.addEventListener('cartUpdate', initializeMixMatch);
  document.addEventListener('shopify:section:load', initializeMixMatch);
  document.addEventListener('submit', (event) => { if (event.target.matches('form[action*="/cart/add"]')) window.setTimeout(initializeMixMatch, 800); });

  } catch(e) { console.error(e); }
})();
})();
